import type { CurrentUser } from "@/types";

export const userNameMock = "Rubem Dornas";

export const userMock: CurrentUser = {
  account_id: "c892db7a-79c2-4529-8829-b55d6e490f7c",
  name: "Rubem Dornas",
  role: "ev",
  language: "en",
};

export const notificationCountMock = 3;

export function getMockCurrentUser(): CurrentUser {
  return userMock;
}
